import { CheckoutAnalyticsService } from '@analytics/feature';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ValidationErrorKeys, ValidationErrors } from '@checkout-v2/const';
import { CheckoutService, CheckoutValidationService } from '@checkout-v2/feature';
import { SdvorButtonComponent, SystemMessageComponent } from '@sdvor/shared/ui/v2';
import { filter, take, tap } from 'rxjs';

@Component({
  selector: 'sd-submit-order',
  templateUrl: './submit-order.component.html',
  styleUrls: ['./submit-order.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SdvorButtonComponent, SystemMessageComponent],
})
export class SubmitOrderComponent {
  readonly fullWidth = input<boolean>(false);

  private readonly checkoutValidationService = inject(CheckoutValidationService);
  private readonly checkoutService = inject(CheckoutService);
  private readonly checkoutAnalyticsService = inject(CheckoutAnalyticsService);

  protected readonly isLoading = toSignal(this.checkoutService.getPlaceOrderLoading(), { initialValue: false });
  protected readonly isError = toSignal(this.checkoutService.getPlaceOrderError(), { initialValue: false });

  protected readonly isConsignmentError = toSignal(this.checkoutService.getCustomerConsignmentError(), {
    initialValue: false,
  });

  protected onSubmit(): void {
    this.checkoutValidationService
      .validate()
      .pipe(
        take(1),
        tap((errors) => {
          if (errors) {
            this.sendToAnalitics(errors);
          }
        }),
        filter((errors) => !errors),
      )
      .subscribe(() => {
        this.checkoutService.placeOrder();
      });
  }

  private sendToAnalitics(errors: ValidationErrors): void {
    Object.keys(errors).forEach((key) => {
      switch (key) {
        case ValidationErrorKeys.DELIVERY_ADDRESS_REQUIRED:
          this.checkoutAnalyticsService.alertNeedDeliveryAdress();
          break;
        case ValidationErrorKeys.PICKUP_ADDRESS_REQUIRED:
          this.checkoutAnalyticsService.alertNeedPickupAdress();
          break;
        case ValidationErrorKeys.PAYMENT_REQUIRED:
          this.checkoutAnalyticsService.alertNeedPaymentMode();
          break;
        case ValidationErrorKeys.TIME_SLOT_REQUIRED:
          this.checkoutAnalyticsService.alertNeedDeliveryDate();
          break;
      }
    });
  }
}
